import React, { useEffect } from 'react';
import { CampaignFormatter } from 'components/tables/NinjaTable/formatters/sourceFormatters';
import { Flex, Checkbox, Tooltip, Spin } from 'antd';
import ninjaApi from 'store/redux/apis';
import { mdiHelpCircleOutline } from '@mdi/js';
import Ninja from '@ninja';
import Icon from '@mdi/react';

const AccountsCollapse = ({ checkedAll, account, onChange, checkedCampaign }) => {
  const [getCampaignsListQuery, { data, isLoading }] = ninjaApi.useLazyCampaignsListQuery();

  useEffect(() => {
    if (account.id) {
      getCampaignsListQuery({
        filters: { network_account_id: account.id },
        per_page: 100,
      }).unwrap();
    }
  }, [account.id]);

  useEffect(() => {
    if (data?.data?.length) {
      if (checkedAll) {
        data.data.map(({ campaign }) => onChange(campaign.id, true));
      }
      // else if (checkedAll == false) {
      //   data.data.map(({ campaign }) => onChange(campaign.id, false));
      // }
    }
  }, [checkedAll, data]);

  if (isLoading) {
    return (
      <div className='ml-14 my-6'>
        <Spin size='small' />
      </div>
    );
  }

  if (!data?.data.length)
    return <p className='text-xs text-color-light  ml-14 my-2'>No Campaigns Found</p>;

  return (
    <div className='grid gap-2 ml-14 mb-4'>
      {data?.data.map(({ campaign }) => {
        return (
          <Flex className='w-full' justify='space-between'>
            <Flex gap='middle' align='center' key={campaign.id}>
              <Checkbox
                checked={checkedCampaign?.includes(campaign.id)}
                onChange={(e) => onChange(campaign.id, e.target.checked)}
              />

              <CampaignFormatter row={{ campaign }} />
            </Flex>
            {checkedCampaign?.includes(campaign.id) && (
              <Tooltip title='Campaign is excluded' placement='top'>
                <Icon path={mdiHelpCircleOutline} color={Ninja.colors.light} />
              </Tooltip>
            )}
          </Flex>
        );
      })}
    </div>
  );
};

export default AccountsCollapse;
